import { translate } from '@appnest/lit-translate';
import { Kode4Field } from "@kode4/form/dist/kode4-field";

(Kode4Field as any).prototype.validate = function() {
  this.error = '';
  if (this.required && !this.disabled && !this.hidden && !this.hasValue) {
      this.error = translate('commons.errors.required');
      return false;
  }

  return true;
}